import styled from 'styled-components';
import { layout, colors } from 'Constants';
import React from 'react';
import HeroImg from '../../views/Home/images/img_homepage_hero.png';
import AnchorLogo from '../images/anchor_logo.png';

const ContainterV2 = styled.h1`
  background-color: ${colors.containerBackground};
  max-width: ${layout.maxWidth};
  margin: 0px auto;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

const HeroText = styled.div`
  font-family: 'Elevance Sans SemiBold';
  font-weight: 600;
  font-size: 60px;
  line-height: 72px;
  text-align: left;
  color: #fff;

  margin-bottom: 32px;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    font-size: 50px;
  }


`;

const LongText = styled.div`
  font-family: 'Elevance Sans medium';
  font-size: 18px;
  line-height: 26px;
  text-align: left;
  color: #fff;
  margin-bottom:40px ;
`;

const HeroLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${props=>props.centered?'center':'flex-start'};
  width: 83%;
  
  align-self: center;
   

  

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    padding: 10px;
    padding-top: 0px;
    width: 100%;
    margin-left:0px ;
  }
`;

const HeroImageDiv = styled.div`
  background-color: #ffffff;
  display: flex;
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    height: auto;
    margin-top: 20px;
  }
`;

const HeroImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 683px;
  object-fit:  cover;
`;

const AnchorImage = styled.img`
  width: 44px;
  height: auto;
`;

const HeroLeftOuter = styled.div`
  padding-left: 25px;
  padding-top: 25px;
  display: flex;
  flex-direction: row;

  flex: 1;
`;

export default ({
  image = HeroImg,
  heroText = 'heading',
  longText = '',
  centered=false,
  children

}) => {
  return (
    <>
      <ContainterV2>
        <HeroLeftOuter>
          <div>
        {false &&   <AnchorImage src={AnchorLogo} />}
          </div>
          <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <HeroLeft centered={centered}>
            <HeroText>{heroText}</HeroText>
            <LongText>{longText}</LongText>
          </HeroLeft>
          </div>
        </HeroLeftOuter>
        <HeroImageDiv>
          <HeroImage alt='hero image' src={image} />
        </HeroImageDiv>
      </ContainterV2>
      <>{children}</>
    </>
  );
};
